"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _constants = require("../../helpers/constants");

var styles =
/*#__PURE__*/
(0, _core.css)("display:inline-block;border-radius:200px;background:white;width:", _constants.CLOCK_SIZE, "px;height:", _constants.CLOCK_SIZE, "px;position:relative;cursor:pointer;touch-action:none;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy9jbG9jay50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHa0IiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvc3R5bGVzL2Nsb2NrLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgQ0xPQ0tfU0laRSB9IGZyb20gJy4uLy4uL2hlbHBlcnMvY29uc3RhbnRzJ1xuXG5jb25zdCBzdHlsZXMgPSBjc3NgXG5cdGRpc3BsYXk6IGlubGluZS1ibG9jaztcblx0Ym9yZGVyLXJhZGl1czogMjAwcHg7XG5cdGJhY2tncm91bmQ6IHdoaXRlO1xuXHR3aWR0aDogJHtDTE9DS19TSVpFfXB4O1xuXHRoZWlnaHQ6ICR7Q0xPQ0tfU0laRX1weDtcblx0cG9zaXRpb246IHJlbGF0aXZlO1xuXHRjdXJzb3I6IHBvaW50ZXI7XG5cdHRvdWNoLWFjdGlvbjogbm9uZTtcbmBcblxuZXhwb3J0IGRlZmF1bHQgc3R5bGVzXG4iXX0= */"));
var _default = styles;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-timekeeper/lib/components/styles/clock.js
// module id = 6309
// module chunks = 39